import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import { ISearchAppState } from '../reducers/index'
import { connect } from 'react-redux';
import { IResults } from '../state-helpers/search-results';
import { IFacetResult, updateFacetSelected, englishFacets, spanishFacets } from '../state-helpers/facets';
import { ConnectedSearchBar } from '../components/search-bar/search-bar'
import { LoadingSpinner } from '../../global/components/loading-spinner'
import { SearchResult } from '../components/search-results/search-result'
import { Error } from '../components/search-results/error'
import { NoResults } from '../components/search-results/no-results'
import { NoAutocompleteResults } from '../components/search-results/no-autocomplete-results'
import { EmptyResults } from '../components/search-results/empty'
import { GetSorts } from '../components/search-bar/sorts'
import { SortGroup } from '../../../App/global/components/inputs/sort/sort';
import { ConnectedFacets } from '../components/facets/facets'
import { ITerm } from '../state-helpers/facets';
import { ISort, ISortField, memberSortModel, initialSortModel } from '../state-helpers/sorts';
import { setSort, setPage, setSortModel, setSearchTerm, setContext, updateSearchFacet, setMobileFacetsVisibility, setSelectedFacetCount } from '../actions/index';
import { fetchResults, getSelectedFacetCount, setFacetsAndCount, FetchResultsFlags } from '../actions/results'
import { fetchAutocompleteResults } from '../actions/autocomplete-results'
import { setUrlFacets } from '../../global/actions/filter-actions';
import { fetchEpiProps } from '../actions/props'
import { Pagination, IPaginationOptions } from '../components/pagination/pagination';
import { pushInUrlQuery, multiPushInUrlQuery } from 'react-url-query';
import { checkFilters } from '../actions/filters';
import { trackClick } from '../actions/track-click'
import { ISearchContext, ContextIds } from '../../global/models/search-context';
import { PopupWarning } from '../../global/components/errors/popup-warning';
import { bindActionCreators } from 'redux';
import { IEpiProps } from '../state-helpers/epi-props';
import { clearErrorText } from '../actions'
import { IPage } from '../state-helpers/page';
import { IAnalytics } from '../../global/functions/analytics';
import { IGlobalSort } from '../../global/state-helpers/sort';
import { WithRouterWrapper } from '../../global/functions/with-router-wrapper';
import { sendShopSearchResultListScriptToGTM } from '../../../Static/javascript/modules/shop-google-analytics';


interface IStateProps {
    epiProps: IEpiProps;
    searchResults: IResults;
    searchTerm: string;
    selectedSearchContext: ISearchContext;
    pageModel: IPage;
    sortsModel: ISort[]
}

interface IDispatchProps {
    fetchEpiProps: () => void;
    fetchResults: (flags: FetchResultsFlags) => void;
    setContext: (context: ISearchContext) => void;
    setPage: (page: number) => void;
    trackClick: (id: string) => void;
    fetchAutocompleteResults: (searchTerm: string) => void;
    setSearchTerm: (term: string) => void;
    setSort: (sortId: string) => void;
    setSortModel: (sortModel: ISort[]) => void;
    updateSearchFacet: (facets: IFacetResult[]) => void;
    setMobileFacetsVisibility: (visible: boolean) => void;
    clearErrorText: (results: IResults) => void;
    setSelectedFacetCount: (count: number) => void;
}

interface IOwnProps {
    isLandingPage: boolean,
    analytics: IAnalytics,
    location: any,
    searchDefaultSort: string,
    searchMembershipSort: string,
    searchPolicySort: string,
    searchPublicationsSort: string,
    searchPointofCareSort: string,
    searchShopSort: string,
    searchHealthyChildrenSort: string,
    searchNewsSort: string,
    searchRedBookSort: string
}

type IOwnRouteProps = IOwnProps 

type IProps = IStateProps & IDispatchProps & IOwnRouteProps

interface IQueryProps {
    k?: string;
    page?: string;
    sort?: string;
    context?: string;
    facets?: string;
    lang?: string;
}

interface IState {
    loadingState: boolean,

    searchContexts: ISearchContext[],

    filterWarning: string,
    showFilterWarning: boolean,
    locationState:any,
}

class SearchApp extends React.Component<IProps, IState> {

    state: IState = {
        loadingState: true,
        searchContexts: [],

        filterWarning: '',
        showFilterWarning: false,
        locationState: this.props.location
    }
    get queryProps(): IQueryProps {
       

        return qs.parse(this.state?.locationState?.search)
    }

    componentWillMount() {
        this.props.fetchEpiProps();
        this.parseQuery();

        // Load everything we need
        this.loadContexts().then(() => {
            // Indicate we're done loading in state
            this.setState({ loadingState: false })

            // If there are no query parameters then the default state should be to load facets and not show results
            // If there are query parameters the router will handle initialization

            // Now that everything is loaded, execute a search if there is a query or context,
            // or just get facets for nothing
            if (this.queryProps.k || this.queryProps.context || this.props.isLandingPage) {
                this.props.fetchResults(FetchResultsFlags.None)
            } else {
                this.props.fetchResults(FetchResultsFlags.OnlyGetFacets)
            }
        })
    }

    componentDidUpdate() {
        sendShopSearchResultListScriptToGTM();
    }

    parseQuery = () => {
        const { queryProps } = this;
        let sortVar = "relevance";
        if (queryProps.k) {
            this.props.setSearchTerm(queryProps.k);
        }
        if (queryProps.page) {
            this.props.setPage(parseInt(queryProps.page))
        }
        if (queryProps.sort) {
            sortVar = queryProps.sort;
        }
        //If the sort is not set in the query props set the default sort according to the context as long as the string is available or it will be relevance
        if (!queryProps.sort) {
            sortVar = this.getDefaultSortValue(queryProps.context);
        }
        this.props.setSort(sortVar);

        // A little excessive
        // Refactoring idea - ONLY selected terms are present in state
        let facets: IFacetResult[] = [];
        if (queryProps.facets) {
            facets = JSON.parse(queryProps.facets).map(facet => ({
                fieldName: facet.fieldName,
                name: facet.name,
                terms: facet.terms.map(term => ({
                    term: term.term,
                    selected: true
                }))
            }));
        }

        if (queryProps.lang) {
            if (queryProps.lang.toLowerCase() === 'english') {
                facets = facets.length
                    ? updateFacetSelected('language', queryProps.lang, facets)
                    : englishFacets;
            }
            if (queryProps.lang.toLowerCase() === 'spanish') {
                facets = facets.length
                    ? updateFacetSelected('language', queryProps.lang, facets)
                    : spanishFacets;
            }
        }
        this.props.updateSearchFacet(facets);
    }

    loadContexts = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            // Fetch the contexts from the API
            fetch('/api/v1/search/advanced/contexts')
                // Grab the JSON data
                .then(res => res.json())
                // Put it in the state, upon completion resolve the promise
                .then(json => this.setState({ searchContexts: json }, () => {
                    const context = json.filter(c => c.id === this.queryProps.context)[0] || json[0];

                    this.props.setContext(context);
                    this.setSortsModel(context.id);
                    if (context.id == 'Members') {
                        let sortVar = this.getDefaultSortValue(context.id);
                        if (this.queryProps.sort) {
                            sortVar = this.queryProps.sort;
                        }
                        //If the sort is not set in the query props set the default sort according to the context as long as the string is available or it will be relevance
                        this.props.setSort(sortVar);
                    }
                    resolve();
                }))
                // Reject the promise on error
                .catch(reject);
        });
    }

    render() {

        if ((window as any).bootstrap.tags != null && (window as any).bootstrap.tags.length > 0 && this.props.searchResults.totalNumber === 0) {
            return null;
        }

        let width = window.innerWidth;
        const pagination = {
            items: this.props.searchResults.totalNumber,
            currentPage: this.props.pageModel.page,
            pageSize: this.props.pageModel.pageSize,
            totalPages: this.props.searchResults.totalPages
        } as IPaginationOptions;

        if (this.state.loadingState || !this.props.selectedSearchContext) {
            return <h1></h1>
        }
        const MemberDirectoryDisclaimer = this.props.epiProps.memberDirectoryDisclaimer;
        return (

            <div className="search-app-container">

                {
                    this.props.searchResults.errorMessage != '' &&
                    <Error
                        epiProps={this.props.epiProps}
                        results={this.props.searchResults}
                        onDismiss={() => this.props.clearErrorText(this.props.searchResults)} />
                }
                {
                    this.state.showFilterWarning &&
                    <PopupWarning
                        warningHtml={this.state.filterWarning}
                        dismissLabel='Dismiss'
                        onDismiss={() => this.setState({ showFilterWarning: false })} />
                }


                <div className="desktop-facets-wrapper">

                    <ConnectedFacets
                        analytics={this.props.analytics} 
                        onUpdateSearchFacet={this.onUpdateSearchFacet} />

                </div>
                <div className="search-content-wrapper" data-search-results>
                    
                    {!this.props.searchResults.loading && this.props.selectedSearchContext.display == "Members" && MemberDirectoryDisclaimer ?
                        <div className="member-directory-disclaimer" dangerouslySetInnerHTML={{ __html: MemberDirectoryDisclaimer}}></div>
                        : null
                    }

                    <ConnectedSearchBar
                        searchContexts={this.state.searchContexts}
                        onContextSelect={this.onContextSelect}
                        analytics={this.props.analytics} />

                    <div className="mobile-facets-wrapper">
                        <ConnectedFacets
                            analytics={this.props.analytics}
                            onUpdateSearchFacet={this.onUpdateSearchFacet} />
                    </div>

                    {/*<ConnectedSorts sorts={this.props.sortsModel} onSortSelect={(sortId: string) => this.onSortSelect(sortId)} epiProps={this.props.epiProps} />*/}

                    {<SortGroup
                        sortGroupName={'sort-desktop'}
                        sorts={GetSorts(this.props.sortsModel, this.props.epiProps)}
                        onSort={(sort: IGlobalSort<IResults>) => this.onSortSelect(sort.sortId)}
                    />}

                    {!this.props.searchResults.loading && this.props.searchResults.searchItemList.some(r => r.isBestBet) ?
                        <div className="search-top-result">
                            <svg>
                                <use xlinkHref="#icon-trending"></use>
                            </svg>
                            <h5>Top Results</h5>
                        </div>
                        : null
                    }

                    <LoadingSpinner loading={this.props.searchResults.loading} />

                    {this.renderNoResults()}
                    {this.renderEmptyResults()}
                    {this.renderSearchResults()}
                    {this.renderPagination(pagination)}
                </div>
            </div>
        );
    }

    renderNoResults = () => {
        const { searchTerm, searchResults, epiProps, selectedSearchContext } = this.props;

        // If we have a seach term & are supposed to show results, no longer loading but there were no results
        if (searchTerm.length > 0 && searchResults.showResults && searchResults.searchItemList && searchResults.searchItemList.length === 0 && !searchResults.loading) {
            // Show a certain message if autocomplete led to no results
            return searchResults.fromAutocomplete
                ? <NoAutocompleteResults epiProps={epiProps} selectedContext={selectedSearchContext} />
                : <NoResults epiProps={epiProps} />
        }
    }

    renderEmptyResults = () => {
        const { searchTerm, searchResults, epiProps } = this.props;

        // Nothing was searched, and we're not loading
        if (searchTerm.length === 0 && searchResults.searchItemList.length === 0 && !searchResults.loading && window.location.search.length === 0) {
            return <EmptyResults epiProps={epiProps} />
        }
    }

    renderSearchResults = () => {
        const { searchResults, epiProps, trackClick } = this.props;

        // We're not loading and got some results
        if (!searchResults.loading && searchResults.searchItemList.length > 0) {
            return searchResults.searchItemList.map((result, index) => (
                <SearchResult
                    epiProps={epiProps}
                    result={result}
                    key={index}
                    onClick={trackClick} />
            ));
        }
    }

    renderPagination = (pagination: IPaginationOptions) => {
        const { searchResults } = this.props;

        // We're not loading and got multiple pages of results
        if (!searchResults.loading && searchResults.searchItemList.length > 0) {
            return <Pagination pagination={pagination} onPageSelect={(page: number) => this.onPageSelect(page)} />
        }
    }

    scrollToTop = () => {
        // Scroll to top of page if search page
        // Scroll to top of body for landing page

        var landingPageContainerElements = document.getElementsByClassName("automatic-landing-page");
        if (landingPageContainerElements.length == 0) {
            window.scroll(0, 0);
        } else {
            document.getElementById("search-page-app").scrollIntoView();
            window.scrollBy(0, -5);

            // Adjust for sticky header
            var stickyHeaderElements = document.getElementsByClassName("header-inner");
            if (stickyHeaderElements.length > 0) {
                window.scrollBy(0, stickyHeaderElements[0].clientHeight * -1);
            }
        }
    }

    getDefaultSortValue = (id) => {
        switch (id) {
            case 'all':
                return this.props.searchDefaultSort ? this.props.searchDefaultSort : 'relevance';
                break;
            case 'Members':
                return this.props.searchMembershipSort ? this.props.searchMembershipSort : 'relevance';
                break;
            case 'Policy':
                return this.props.searchPolicySort ? this.props.searchPolicySort : 'relevance';
                break;
            case 'Publication':
                return this.props.searchPublicationsSort ? this.props.searchPublicationsSort : 'relevance';
                break;
            case 'Point-of-Care':
                return this.props.searchPointofCareSort ? this.props.searchPointofCareSort : 'relevance';
                break;
            case 'Shop':
                return this.props.searchShopSort ? this.props.searchShopSort : 'relevance';
                break;
            case 'Healthy Children':
                return this.props.searchHealthyChildrenSort ? this.props.searchHealthyChildrenSort : 'relevance';
                break;
            case 'News Releases':
                return this.props.searchNewsSort ? this.props.searchNewsSort : 'relevance';
                break;
            case 'Red Book Online':
                return this.props.searchRedBookSort ? this.props.searchRedBookSort : 'relevance';
                break;
            default:
                return this.props.searchDefaultSort ? this.props.searchDefaultSort : 'relevance';
        }
    }

    onSortSelect = (sortId: string) => {
        this.props.setPage(1);

        const oldSort = this.props.sortsModel
            .filter(s => s.selected)
            .map(s => s.id)
            .reduce((prev, id) => id);
        this.props.analytics.onSortChanged(oldSort, sortId);

        this.props.setSort(sortId);
        this.props.fetchResults(FetchResultsFlags.None);
        multiPushInUrlQuery({ sort: sortId, page: '1' });
        this.scrollToTop();
    }

    onRefinementSelect = (sortId: string) => {
        this.props.setSort(sortId);
        this.props.fetchResults(FetchResultsFlags.None);
        pushInUrlQuery('page', '1');
    }

    onPageSelect = (page: number) => {

        const oldPage = this.props.pageModel.page;
        this.props.analytics.onPageChanged(oldPage, page);

        this.props.setPage(page);
        this.props.fetchResults(FetchResultsFlags.None);
        pushInUrlQuery('page', page);
        this.scrollToTop();
    }


    setSortsModel = (contextId: string) => {
        if (contextId === ContextIds.members) {
            this.props.setSortModel(memberSortModel);
        }
        else {
            this.props.setSortModel(initialSortModel);
        }
    }

    onContextSelect = (contextId: string) => {
        const oldContext = this.props.selectedSearchContext;
        const newContext = this.state.searchContexts.filter(c => c.id === contextId)[0];

        const defaultSort = this.getDefaultSortValue(contextId);
        // Notify google tag manager
        this.props.analytics.onContextChanged(oldContext.display, newContext.display);

        this.setSortsModel(contextId);

        this.props.setPage(1);
        this.props.setSort(defaultSort);
        //Reset facets when switching contexts
        multiPushInUrlQuery({ context: contextId, page: '1', facets: null, sort: defaultSort, k: this.props.searchTerm });
        this.props.updateSearchFacet([]);
        this.props.setMobileFacetsVisibility(false);
        this.props.setContext(newContext);
        this.props.fetchResults(FetchResultsFlags.None);

        // Check the search filters
        const { searchTerm } = this.props;
        const badFilters = checkFilters(newContext, searchTerm);

        if (badFilters.length > 0) {
            const warning = this.props.epiProps.filterWarningText
                .replace('{{context}}', newContext.display)
                .replace('{{filters}}', badFilters.join(', '));
                
            this.setState({
                filterWarning: warning,
                showFilterWarning: true
            })
        }

        this.scrollToTop();
    }

    onUpdateSearchFacet = (facets: IFacetResult[]) => {
        this.props.setPage(1);
        this.props.updateSearchFacet(facets);
        this.props.setSelectedFacetCount(getSelectedFacetCount(facets));

        this.props.fetchResults(FetchResultsFlags.None);
        var selectedFacets = facets
            .map((item, i) => {
                return item.terms.some(f => f.selected === true)
                    ? { name: item.name, fieldName: item.fieldName, terms: item.terms.filter(t => t.selected === true) } : null
            })
            .filter(f => f != null);
        var facetList = JSON.stringify(selectedFacets);
        setUrlFacets(facets);
        
        multiPushInUrlQuery({
            context: this.props.selectedSearchContext.id
        });
        
        this.scrollToTop();
    }
}

const mapStateToProps = (state: ISearchAppState): IStateProps => ({
    epiProps: state.epiPropsModel,
    searchResults: state.resultsModel,
    searchTerm: state.searchTermModel,
    selectedSearchContext: state.selectedSearchContext,
    pageModel: state.pageModel,
    sortsModel: state.sortsModel
})

const mapDispatchToProps = (dispatch, ownProps: IOwnProps): IDispatchProps => {
    return bindActionCreators({
        fetchEpiProps,
        fetchResults: fetchResults(ownProps.analytics),
        setContext,
        setPage,
        trackClick,
        fetchAutocompleteResults,
        setSearchTerm,
        setSort,
        setSortModel,
        updateSearchFacet,
        setMobileFacetsVisibility,
        clearErrorText,
        setSelectedFacetCount
    }, dispatch);
}

export const SearchPageApp = WithRouterWrapper(connect<IStateProps, IDispatchProps, IOwnRouteProps>(mapStateToProps, mapDispatchToProps)(SearchApp));

